<template>
    <div>
        <input type="number" :min="formElement.dynamicTypeData.min" :max="formElement.dynamicTypeData.max" v-model="formElement.dynamicTypeData.value" />
        <p class="error" v-if="formElement.dynamicTypeData.isValid !== undefined && !formElement.dynamicTypeData.isValid" v-html="formElement.dynamicTypeData.errorText" />
    </div>
</template>

<script>
export default {
  name: "kollecto-number",
  props: ["formElement", "userAction"],
  created() {
    if (this.userAction === "create" || !this.userAction) {
      if (this.formElement.dynamicTypeData.defaultValue) {
        this.formElement.dynamicTypeData.value = this.formElement.dynamicTypeData.defaultValue;
      }
    }
  }
};
</script>
